import '@/design/tailwind-only.css'
import app from '@/config/configApp'
import { createAuth0 } from '@auth0/auth0-vue'
import VueApollo from 'vue-apollo'
import Toast, { PluginOptions } from 'vue-toastification'
import { initRouter } from './router'
import { createI18n } from 'vue-i18n'
import en from '@/locales/en'
import ar from '@/locales/ar.json'
import de from '@/locales/de.json'
import ee from '@/locales/ee.json'
import es from '@/locales/es.json'
import ka from '@/locales/ka.json'
import ru from '@/locales/ru.json'
import uk from '@/locales/uk.json'
import li from '@/locales/li.json'
import { store, key } from './store'
import { client } from './lib/api'
// import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.less'

import './design/vue2Dropzone.min.css'
import '@vueform/multiselect/themes/default.css'
import 'vue-toastification/dist/index.css'

import './design/style.scss'
import './design/_fonts.scss'

import '@/core/plugins/ant-design'
import '@/core/plugins/fonts'
import '@/core/plugins/maps'
import '@/core/plugins/masonry'
import '@/core/plugins/apexcharts'
import '@/core/components/custom'
import '@/core/components/style'

import QrcodeVue from 'qrcode.vue'

const apollo = new VueApollo({
  defaultClient: client
})

const authConfig = {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  client_id: process.env.VUE_APP_AUTH0_CLIENTID,
  redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URL,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE
}

const toastConfig: PluginOptions = {}

const i18n = createI18n({
  legacy: false,
  local: 'en', // TODO store user selection to local storage and use here
  messages: {
    en, ar, de, es, ee, ru, uk, ka, li
  }
})

const router = initRouter(app)

app
  .use(router)
  .use(apollo)
  .use(store, key)
  .component('qr-code', QrcodeVue)
  .use(Toast, toastConfig)
  .use(i18n)
  .use(createAuth0({
    domain: authConfig.domain,
    client_id: authConfig.client_id,
    redirect_uri: authConfig.redirect_uri,
    audience: authConfig.audience,
        authorizationParams: {
      redirect_uri: window.location.origin,
    },
    onRedirectCallback(appState) {
      const target = appState?.targetUrl || window.location.pathname
      router.replace(target)
    },
  }))

  app.mount('#app')